module.exports = __webpack_public_path__ + "static/media/intro-1@2x.62e3d05b.jpg";